<template>
    <div class="form-field form-code" :rel="name" v-bind:class="{'form-required': requiredForm}">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <button @click="preview()">Preview</button>
            <div class="form-input-wrapper">
                <prism-editor v-model="internalValue" :language="language"></prism-editor>
                <i :class="langClass" v-if="lang"><img :src="'/src/assets/flags/'+lang+'.svg'"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormCodeTextarea',
        props: ['value','label','name','placeholder','lang','required','language'],
        data: function () {
            return {
                internalValue: '',
                langClass: ''
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.langClass = this.lang?"flag lang-"+this.lang:"";
            this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
        },
        methods: {
            preview: function(){
                var x=window.open();
                x.document.open();
                x.document.write( this.internalValue );
                x.document.close();
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Code.vue